import i18next from 'i18next'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'
import enTranslation from './en.json'
import plTranslation from './pl.json'
import esTranslation from './es.json'
import frTranslation from './fr.json'
import deTranslation from './de.json'
import config from '../config'

import errors from './errors'

import { translations } from 'modules'

export const DEFAULT_LANGUAGE = 'pl'
export const DEFAULT_NAMESPACE = 'common'

const resources = {
  en: { [DEFAULT_NAMESPACE]: enTranslation },
  pl: { [DEFAULT_NAMESPACE]: plTranslation },
  es: { [DEFAULT_NAMESPACE]: esTranslation },
  fr: { [DEFAULT_NAMESPACE]: frTranslation },
  de: { [DEFAULT_NAMESPACE]: deTranslation },
}

const addModulesTranslations = () => {
  translations.forEach(translation =>
    // @ts-ignore
    i18next.addResourceBundle(...translation, true)
  )
}
const addErrorTranslations = () => {
  errors.forEach(translation =>
    // @ts-ignore
    i18next.addResourceBundle(...translation, true)
  )
}

export const getDefaultLang = () =>
  localStorage.getItem(config.languageKey) || DEFAULT_LANGUAGE

i18next
  .use(Backend)
  .use(initReactI18next)
  .init({
    resources,
    lng: getDefaultLang(),
    fallbackLng: getDefaultLang(),
    defaultNS: DEFAULT_NAMESPACE,
    fallbackNS: DEFAULT_NAMESPACE,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
  })

addErrorTranslations()
addModulesTranslations()

export default i18next
